module.exports = __webpack_public_path__ + "static/intro_final_mobile_poster-1ee702dfdb8a82bc11db6fcc4af6fb51.png";